<template>
  <div
    class="ba-wrap"
    ref="wrap"
    @pointerdown="startDrag"
  >
    <img :src="after" class="ba-img" draggable="false" alt="" />

    <div class="ba-before-layer" :style="{ clipPath: `inset(0 ${100 - percent}% 0 0)` }">
      <img :src="before" class="ba-img" draggable="false" alt="" />
    </div>

    <div class="ba-divider" :style="{ left: percent + '%' }">
      <div class="ba-handle">
        <v-icon size="16" color="white">mdi-unfold-more-horizontal</v-icon>
      </div>
    </div>

    <span class="ba-label ba-label-before">بعد</span>
    <span class="ba-label ba-label-after">قبل</span>
  </div>
</template>

<script>
export default {
  name: 'BeforeAfterSlider',
  props: {
    before: { type: String, required: true },
    after: { type: String, required: true },
  },
  data: () => ({
    percent: 50,
    dragging: false,
  }),
  methods: {
    startDrag(e) {
      e.stopPropagation();
      this.dragging = true;
      this.updateFromEvent(e);
      window.addEventListener('pointermove', this.onDrag);
      window.addEventListener('pointerup', this.endDrag);
    },
    onDrag(e) {
      if (!this.dragging) return;
      this.updateFromEvent(e);
    },
    endDrag() {
      this.dragging = false;
      window.removeEventListener('pointermove', this.onDrag);
      window.removeEventListener('pointerup', this.endDrag);
    },
    updateFromEvent(e) {
      const rect = this.$refs.wrap.getBoundingClientRect();
      if (!rect.width) return;
      let x = ((e.clientX - rect.left) / rect.width) * 100;
      x = Math.max(0, Math.min(100, x));
      this.percent = x;
    },
  },
  beforeUnmount() {
    window.removeEventListener('pointermove', this.onDrag);
    window.removeEventListener('pointerup', this.endDrag);
  },
};
</script>

<style scoped>
.ba-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  touch-action: none;
  cursor: ew-resize;
  user-select: none;
}
.ba-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
  pointer-events: none;
}
.ba-before-layer {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}
.ba-divider {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  background: rgba(255,255,255,0.85);
  box-shadow: 0 0 8px rgba(0,0,0,0.5);
  transform: translateX(-1px);
  pointer-events: none;
}
.ba-handle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(90deg);
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(0,0,0,0.55);
  backdrop-filter: blur(4px);
  border: 2px solid rgba(255,255,255,0.85);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ba-label {
  position: absolute;
  top: 10px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  border-radius: 999px;
  background: rgba(0,0,0,0.55);
  color: #fff;
  pointer-events: none;
}
.ba-label-before { right: 10px; }
.ba-label-after { left: 10px; }
</style>
